import { getCookie } from '../cookies/getCookie.js';
import { isString } from '../isString/isString.js';
import { isUndefined } from '../isUndefined/isUndefined.js';
import { PROPERTY_ID_MAIN, PROPERTY_ID_SUBDOMAIN } from './lib/sourcepointConfig.js';
const purposeIdToNonAdvertisingPurposesMap = /* @__PURE__ */ new Map([
    [1, "677e3387b265dc07332909da"],
    // 1
    [2, "677e3386b265dc073328f686"],
    //2
    [3, "677e3386b265dc073328f96f"],
    // 3
    [4, "677e3386b265dc073328fc01"],
    //4
    [5, "677e3386b265dc073328fe72"],
    // 5
    [6, "677e3386b265dc073328ff70"],
    //6
    [7, "677e3386b265dc0733290050"],
    //7
    [8, "677e3386b265dc07332903c8"],
    //8
    [9, "677e3386b265dc0733290502"],
    //9
    [10, "677e3386b265dc073329071a"],
    //10
    [11, "677e3386b265dc07332909c2"]
    //11
]);
const spBaseUrl = "https://cdn.privacy-mgmt.com/consent/tcfv2/consent/v3";
const mergeVendorList = async () => {
    const userConsent = await getUserConsentForAdvertisingVendorList();
    const purposesAndVendors = getConsentedPurposesandVendorsStrings(userConsent);
    if (!isUndefined(purposesAndVendors)) {
        await sendUserCustomConsentToNonAdvertisingVendorList(purposesAndVendors.vendors, purposesAndVendors.purposes, purposesAndVendors.legitimateInterestPurposeIds);
        await sendUserConsentStringToNonAdvertisingVendorList();
    }
};
const getUserConsentForAdvertisingVendorList = async () => {
    const consentUUID = getCookie({ name: "consentUUID" });
    const url = `${spBaseUrl}/history/${PROPERTY_ID_MAIN}?consentUUID=${consentUUID}`;
    const getUserConsentOnAdvertisingListResponse = await fetch(url, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    });
    return await getUserConsentOnAdvertisingListResponse.json();
};
const getConsentedPurposesandVendorsStrings = (data) => {
    const vendorIds = data[0]?.vendors.map((vendor) => vendor._id);
    const purposeIds = data[0]?.categories.map((category) => purposeIdToNonAdvertisingPurposesMap.get(category.iabPurposeRef.iabId) ?? "").filter(isString);
    const legitimateInterestPurposeIds = data[0]?.legIntCategories.map((category) => purposeIdToNonAdvertisingPurposesMap.get(category.iabPurposeRef.iabId) ?? "").filter(isString);
    if (vendorIds && purposeIds && legitimateInterestPurposeIds) {
        return {
            vendors: vendorIds,
            purposes: purposeIds,
            legitimateInterestPurposeIds
        };
    }
    else {
        return void 0;
    }
};
const sendUserCustomConsentToNonAdvertisingVendorList = async (vendorIds, purposeIds, legitimateInterestPurposeIds) => {
    const consentUUID = getCookie({ name: "consentUUID" });
    const url = `${spBaseUrl}/custom/${PROPERTY_ID_SUBDOMAIN}?hasCsp=true&consentUUID=${consentUUID}`;
    await makePOSTRequest(url, {
        vendors: vendorIds,
        categories: purposeIds,
        legIntCategories: legitimateInterestPurposeIds
    });
};
const sendUserConsentStringToNonAdvertisingVendorList = async () => {
    const consentUUID = getCookie({ name: "consentUUID" });
    const url = `${spBaseUrl}/${PROPERTY_ID_SUBDOMAIN}/tcstring?consentUUID=${consentUUID}`;
    const spUserConsentString = localStorage.getItem(`_sp_user_consent_${PROPERTY_ID_MAIN}`);
    const userConsent = JSON.parse(spUserConsentString ?? "{}");
    await makePOSTRequest(url, {
        euconsent: userConsent.gdpr?.euconsent
    });
};
const makePOSTRequest = async (url, body) => {
    await fetch(url, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
};
export { mergeVendorList };
